// Generated file : do not modify
export enum DocumentDests
{
  NONE = 0,
  AGETA,
  EMPLOYEUR,
  SALARIE,
  EMPLOYEUR_SALARIE
};

export enum DocumentModes
{
  NONE = 0,
  NORMAL,
  OLD_SUMMARY,
  DETAIL,
  EXCEL,
  DOWNLOAD
};

import { ListFilter } from '@/extend/classes/ListData';
import { PdfNotif } from '@/extend/classes/Route';
import ListData from '@/extend/classes/ListData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Documents
export class ObjType {
  // 
  public type: ObjTypes;
  // 
  public id: number;

  constructor() {
    this.type = ObjTypes.NONE;
    this.id = 0;
  }
}

export default class Document  {
  // Identifiant unique
  public id: number;
  // Destinataire
  public dest: DocumentDests;
  // Référence
  public reference: string;
  // Informations selon le typeId ex: 100,00 € BRUT
  public info: string;
  // Type
  public typeId: number;
  // Catégorie
  public categoryId: number;
  // Gestionnaire
  public gestionnaireId: number;
  // Signataire
  public signataireId: number;
  // Salarié
  public salarieId: number;
  // Etablissement
  public etablissementId: number;
  // Période
  public dateDebut: Date;
  // Date de fin si applicable
  public dateFin: Date | null;
  // Soumis
  public submitted: boolean;
  // Lu client
  public isReadEmployeur: boolean;
  // Lu salarie
  public isReadSalarie: boolean;
  // Finalisé
  public final: boolean;
  // Persistant
  public persistant: boolean;
  // Objet de rattachement pour générateur
  public objType: ObjTypes;
  // ID objet de rattachement (= id si objType == NONE)
  public objId: number;
  // Nom du fichier dans le coffre-fort
  public fileName: string;
  // Extension du fichier
  public fileExtension: string;
  // Taille du fichier en Kb
  public fileSize: number;
  // Chemin du fichier
  public filePath: string;
  // Mode d'affichage du document
  public mode: DocumentModes;
  // affiche les modifications du document
  public showModif: boolean;
  // Indice de révision du fichier (gestion du cache HTTP)
  public revision: number;
  // Document rechargé après modification via ses liens
  public reload: boolean;
  // document produit et stocké par ci98
  public ci98: boolean;
  // Contrat ID oodrive
  public oodriveContratId: number;
  // Salarie ID oodrive
  public oodriveSalarieId: number;
  // Representant ID oodrive
  public oodriveRepresentantId: number;
  // Contrat
  public contratId: number;
  // Projet
  public projetId: number;
  // Document id edusign
  public eduSignDocId: string;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.dest = DocumentDests.NONE;
    this.reference = '';
    this.info = '';
    this.typeId = 0;
    this.categoryId = 0;
    this.gestionnaireId = 0;
    this.signataireId = 0;
    this.salarieId = 0;
    this.etablissementId = 0;
    this.dateDebut = new Date(1901,1,1,0,0,0,0);
    this.dateFin = null;
    this.submitted = false;
    this.isReadEmployeur = false;
    this.isReadSalarie = false;
    this.final = false;
    this.persistant = false;
    this.objType = ObjTypes.NONE;
    this.objId = 0;
    this.fileName = '';
    this.fileExtension = '';
    this.fileSize = 0;
    this.filePath = '';
    this.mode = DocumentModes.NONE;
    this.showModif = false;
    this.revision = 0;
    this.reload = false;
    this.ci98 = false;
    this.oodriveContratId = 0;
    this.oodriveSalarieId = 0;
    this.oodriveRepresentantId = 0;
    this.contratId = 0;
    this.projetId = 0;
    this.eduSignDocId = '';
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Document): Document {
    const newDocument: Document = new Document();
    newDocument.id = obj.id;
    newDocument.dest = obj.dest;
    newDocument.reference = obj.reference;
    newDocument.info = obj.info;
    newDocument.typeId = obj.typeId;
    newDocument.categoryId = obj.categoryId;
    newDocument.gestionnaireId = obj.gestionnaireId;
    newDocument.signataireId = obj.signataireId;
    newDocument.salarieId = obj.salarieId;
    newDocument.etablissementId = obj.etablissementId;
    newDocument.dateDebut = new Date(obj.dateDebut);
    newDocument.dateFin = obj.dateFin ? new Date(obj.dateFin) : null;
    newDocument.submitted = obj.submitted;
    newDocument.isReadEmployeur = obj.isReadEmployeur;
    newDocument.isReadSalarie = obj.isReadSalarie;
    newDocument.final = obj.final;
    newDocument.persistant = obj.persistant;
    newDocument.objType = obj.objType;
    newDocument.objId = obj.objId;
    newDocument.fileName = obj.fileName;
    newDocument.fileExtension = obj.fileExtension;
    newDocument.fileSize = obj.fileSize;
    newDocument.filePath = obj.filePath;
    newDocument.mode = obj.mode;
    newDocument.showModif = obj.showModif;
    newDocument.revision = obj.revision;
    newDocument.reload = obj.reload;
    newDocument.ci98 = obj.ci98;
    newDocument.oodriveContratId = obj.oodriveContratId;
    newDocument.oodriveSalarieId = obj.oodriveSalarieId;
    newDocument.oodriveRepresentantId = obj.oodriveRepresentantId;
    newDocument.contratId = obj.contratId;
    newDocument.projetId = obj.projetId;
    newDocument.eduSignDocId = obj.eduSignDocId;
    newDocument.createId = obj.createId;
    newDocument.failed = obj.failed;
    newDocument.canUpdate = obj.canUpdate;
    newDocument.canDelete = obj.canDelete;
    newDocument.display = obj.display;
    newDocument.clientId = obj.clientId;
    newDocument.notifDefType = obj.notifDefType;
    return newDocument;
  }

  public toJsonDocument (): string {
    const json = {
      dest: this.dest,
      reference: this.reference,
      info: this.info,
      typeId: this.typeId,
      categoryId: this.categoryId,
      gestionnaireId: this.gestionnaireId,
      signataireId: this.signataireId,
      salarieId: this.salarieId,
      etablissementId: this.etablissementId,
      dateDebut: this.dateDebut ? new Date (this.dateDebut).toString() : this.dateDebut,
      dateFin: this.dateFin ? new Date (this.dateFin).toString() : this.dateFin,
      submitted: this.submitted,
      isReadEmployeur: this.isReadEmployeur,
      isReadSalarie: this.isReadSalarie,
      final: this.final,
      persistant: this.persistant,
      objType: this.objType,
      objId: this.objId,
      fileName: this.fileName,
      fileExtension: this.fileExtension,
      fileSize: this.fileSize,
      filePath: this.filePath,
      mode: this.mode,
      showModif: this.showModif,
      revision: this.revision,
      reload: this.reload,
      ci98: this.ci98,
      oodriveContratId: this.oodriveContratId,
      oodriveSalarieId: this.oodriveSalarieId,
      oodriveRepresentantId: this.oodriveRepresentantId,
      contratId: this.contratId,
      projetId: this.projetId,
      eduSignDocId: this.eduSignDocId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromDocument (obj: Document): void {
    this.id = obj.id;
    this.dest = obj.dest;
    this.reference = obj.reference;
    this.info = obj.info;
    this.typeId = obj.typeId;
    this.categoryId = obj.categoryId;
    this.gestionnaireId = obj.gestionnaireId;
    this.signataireId = obj.signataireId;
    this.salarieId = obj.salarieId;
    this.etablissementId = obj.etablissementId;
    this.dateDebut = new Date(obj.dateDebut);
    this.dateFin = obj.dateFin;
    this.submitted = obj.submitted;
    this.isReadEmployeur = obj.isReadEmployeur;
    this.isReadSalarie = obj.isReadSalarie;
    this.final = obj.final;
    this.persistant = obj.persistant;
    this.objType = obj.objType;
    this.objId = obj.objId;
    this.fileName = obj.fileName;
    this.fileExtension = obj.fileExtension;
    this.fileSize = obj.fileSize;
    this.filePath = obj.filePath;
    this.mode = obj.mode;
    this.showModif = obj.showModif;
    this.revision = obj.revision;
    this.reload = obj.reload;
    this.ci98 = obj.ci98;
    this.oodriveContratId = obj.oodriveContratId;
    this.oodriveSalarieId = obj.oodriveSalarieId;
    this.oodriveRepresentantId = obj.oodriveRepresentantId;
    this.contratId = obj.contratId;
    this.projetId = obj.projetId;
    this.eduSignDocId = obj.eduSignDocId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
  }

  public compareDocument (value: Document): boolean {
    return (this.toJsonDocument() == value.toJsonDocument());
  }

  public cloneDocument (): Document {
    return Document.fromJson(this);
  }

  public createForStoreDocument (): Promise<Document> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documents/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromDocument(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreDocument (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/documents/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documents/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static upload (file: File): Promise<Document> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documents/upload', file, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Document.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static updatePdf (pdfNotif: PdfNotif): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documents/updatePdf', pdfNotif, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getByObj (document: Document): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documents/getByObj', document, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getByObjType (objType: ObjType): Promise<Document> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/documents/getByObjType', objType, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Document.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Documents/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Document.fromJson(listData.reccords[0] as Document);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Document> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Documents/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Document.fromJson(listData.reccords[0] as Document);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(documents: Document[]) {
    documents.forEach((item) => {
      item.dateDebut = item.dateDebut ? new Date(item.dateDebut) : item.dateDebut;
      item.dateFin = item.dateFin ? new Date(item.dateFin) : item.dateFin;
    })
  }
}
